import { NAME as namespace } from './constants';
import FapiaoStatusComponent from './components/FapiaoStatus';
import CancelFapiaoLinkContainer from './components/CancelFapiaoLinkContainer';
import reducer from './reducer';
export var CancelFapiaoLink = CancelFapiaoLinkContainer;
export var FapiaoStatus = FapiaoStatusComponent;
export var fapiao = {
  namespace: namespace,
  reducer: reducer
};